import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox, Icon, Spinner, Text } from '@dixa/lib-shared-habla';
import { colors } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import { AppLink } from 'components/appLink';
import styles from './analyticsSidenavItem.module.scss';
export const AnalyticsSidenavItem = ({ item, }) => {
    const renderItem = () => {
        const baseProps = {
            className: classNames(styles.item, {
                [styles.itemActive]: item.active,
                [styles.itemLink]: item.type === 'link',
                [styles.itemButton]: item.type === 'button',
            }),
            role: 'menuitem',
        };
        const iconAndTitle = (_jsxs(_Fragment, { children: [item.icon && (_jsx(FlexBox, Object.assign({ role: "img", "aria-label": item.title }, { children: item.type === 'accordion' && item.options.isLoading ? (_jsx(Spinner, { size: 20 })) : (_jsx(Icon, { className: styles.icon, name: item.icon, color: colors.neutral['700'], size: 20 })) }))), _jsx(Text.Paragraph, Object.assign({ className: styles.title, variant: "1" }, { children: item.title }))] }));
        switch (item.type) {
            default:
            case 'accordion':
                return (_jsxs("div", Object.assign({}, baseProps, { children: [iconAndTitle, " ", item.options.action] })));
            case 'link':
                return (_jsx(AppLink, Object.assign({}, baseProps, item.options, { children: iconAndTitle })));
            case 'button':
                return (_jsx("button", Object.assign({}, baseProps, item.options, { children: iconAndTitle })));
        }
    };
    const renderSubItems = () => {
        if (item.type !== 'accordion') {
            return null;
        }
        const { subItems, isLoading, emptyState } = item.options;
        if (!isLoading && !subItems.length) {
            return (_jsx(FlexBox, Object.assign({ justifyContent: "center", padding: "200" }, { children: emptyState })));
        }
        return (_jsx(FlexBox, Object.assign({ flexDirection: "column", gap: "100", className: styles.subItems }, { children: item.options.subItems.map((subItem) => {
                return (_jsx(AppLink, Object.assign({ className: classNames(styles.subItem, {
                        [styles.subItemActive]: subItem.active,
                    }) }, subItem.options, { children: _jsx(Text.Paragraph, Object.assign({ variant: "2" }, { children: subItem.title })) }), subItem.title));
            }) })));
    };
    return (_jsxs(_Fragment, { children: [renderItem(), renderSubItems()] }));
};
